export default "__VITE_ASSET__57cf62f5__"